import "./project.page.scss";
import { PROJECTS_DATA } from "../../data/pages/projects/projects.data";
import { useContext } from "react";
import { LanguageContext } from "../../contexts/language/language.context";

const Project = () => {
  const { l } = useContext(LanguageContext);
  let projectData = PROJECTS_DATA.en;
  if (l.code === "fr") {
    projectData = PROJECTS_DATA.fr;
  }
  if (l.code === "en") {
    projectData = PROJECTS_DATA.en;
  }
  return (
    <div className="project-container">
      {projectData.map((projectSection) => (
        <div
          className={`project-section project-as-${projectSection.label}`}
          key={projectSection.label}
        >
          <div
            className="project-background"
            style={{ backgroundImage: `url(${projectSection.cover})` }}
          >
            <div className="mask-1"></div>
            <div className="mask-2"></div>
          </div>

          <div className="title-wrapper">
            <div className="title">
              <p>{projectSection.subtitle}</p>
              <h3>{projectSection.title}</h3>
            </div>
          </div>
          <div className="project-list">
            {projectSection.projects.map((project, index) => (
              <div className="project-item" key={project.title + index}>
                <div className="project-header">
                  <div className="project-title">
                    <p>{project.title}</p>
                    <p>{project.description}</p>
                  </div>
                  <div className="project-company-logo">
                    <img alt="image" src={project.logo} />
                  </div>
                </div>
                <div
                  className="project-image"
                  style={{ backgroundImage: `url(${project.image})` }}
                ></div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Project;
